import { CSSProperties } from 'react';

export const containerStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '16px 18px',
  borderRadius: '14px',
  fontSize: '15px',
  border: 'none',
  backgroundColor: '#fff',
  boxSizing: 'border-box',
  boxShadow: '0 1px 4px rgba(0, 0, 0, 0.04)',
  cursor: 'pointer'
};

export const beforeStyle: CSSProperties = {
  marginRight: '15px',
  color: '#1A1A1A',
  fontWeight: '400'
};

export const afterStyle: CSSProperties = {
  marginLeft: 'auto',
  marginRight: '12px',
  color: '#1A1A1A',
  fontWeight: '500'
};
